<template>
  <v-card>
      <v-toolbar
        dense
        flat
        color="primary"
        dark
      >
        Import Option List
      </v-toolbar>
      <v-card-text>
        <v-textarea
            v-model="optionsList"
            label="Options to Import"
            hide-details
        >

        </v-textarea>
        <br />
        <v-card>
            <v-card-text>
                <v-label>
                    <b>Delimiter</b>
                </v-label>
                <v-radio-group
                    v-model="delimiter"
                    hide-details
                    row
                >
                    <v-radio
                        label="New Line"
                        value="newline"
                    />
                    <v-radio
                        label="Comma (,)"
                        value="comma"
                    />
                    <v-radio
                        label="Other"
                        value="other"
                    />
                </v-radio-group>
                <v-text-field
                    v-if="delimiter == 'other'"
                    v-model="other"
                    label="Other Delimiter"
                    hint="The character or string you want to split the options by"
                />
            </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
          <v-spacer />
          <v-btn
            @click="$emit('cancel')"
          >
              Cancel
          </v-btn>
          <v-btn
            :disabled="!optionsList"
            color="primary"
            @click="process()"
          >
              Import
          </v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'OptionListImporter',
  data () {
    return {
      optionsList: "",
      delimiter: "newline",
      other: null
    }
  },
  methods: {
    process () {
        var options = []
        if (this.delimiter == "newline")
            options = this.optionsList.split(/\r?\n/)
        else if (this.delimiter == "comma")
            options = this.optionsList.split(',')
        else if (this.delimiter == "other")
            options = this.optionsList.split(this.other)
        options = options.map(o => o.trim())
        this.$emit('save', options.filter(e => e))
    }
  }
}
</script>

<style scoped>
.list-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
</style>
